const toBase64 = (file) =>
	new Promise((resolve, reject) => {
		const reader = new FileReader();
		reader.readAsDataURL(file);
		reader.onload = () => resolve(reader.result);
		reader.onerror = (error) => reject(error);
	});

const validateSize = (fileList, size) => {
	if (fileList && fileList.length) {
		const file = fileList[0];
		if (file.size > size) return false;
	}
	return true;
};

export default {
	toBase64,
	validateSize,
};
